export default {
  dark: "Theme Dark",
  light: "Theme Light",
  metric: "Metric",
  imperial: "Imperial",
  messages: {
    updateSuccess: "Your profile was updated successfully"
  },
  tabs: {
    basicInfo: "BASIC INFORMATION",
    tasks: "TASKS"
  },
  titles: {
    profile: "Profile",
    tasks: "My Tasks"
  },
  labels: {
    maintenance: "Maintenance",
    repair: "Repair",
    reliability: "Reliability",
    recurrent: "Recurrent",
    onetime: "Onetime",
    done: "Done"
  },
  buttons: {
    gotoModules: "Modules"
  }
};
